import * as React from 'react';
import { createStyles, Group, Text, Box, ActionIcon, useMantineTheme } from '@mantine/core';
import { IconChevronRight } from '@tabler/icons-react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';

// API
import { GetOrganizationById } from '../../api';

// Contexts
import { AuthContext } from '../../contexts/Auth';

// Components
import { Spinner } from '../../components/Spinner';

const useStyles = createStyles((theme) => ({
    orgDetails: {
        cursor: 'pointer',
        flex: 1,
        borderBottom: '1px solid #dee2e6',
        flexWrap: 'nowrap',
        paddingTop: '6px',
        paddingBottom: '6px',
        background: '#f9fcff',
        color: theme.colors.blue[8]
        // color: theme.colors.brand[6],
        // background: theme.colors.brand[0]
    },
    text: {
        // color: '#546376',
        color: theme.colors.blue[8],
        // color: theme.colors.brand[6],
        maxWidth: '10rem',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }
}));

export const OrganizationWidget: React.FC = () => {
    const { authState } = React.useContext(AuthContext);
    const theme = useMantineTheme();
    const { classes } = useStyles();
    const { t } = useTranslation();
    const { isLoading, data: orgData } = useQuery({
        queryKey: ['clientRecordById', authState?.clientId],
        queryFn: async () => {
            const response = await GetOrganizationById(authState?.clientId ?? '');

            return response;
        },
        enabled: Boolean(authState?.clientId?.length),
        refetchOnWindowFocus: false
    });

    if (isLoading) return <Spinner />;
    return orgData ? (
        <Box className={classes.orgDetails} px="md">
            {/* <Text size="xs">{t('organization', { ns: 'common' })}</Text> */}
            <NavLink to={'/client/profile'}>
                <Group position="apart">
                    <Text weight={500} size="sm" sx={{ lineHeight: 1.3 }} className={classes.text}>
                        {orgData.dba || orgData.name}
                    </Text>
                    <ActionIcon variant="transparent" color={theme.colors.brand[6]}>
                        <IconChevronRight size={14} />
                    </ActionIcon>
                </Group>
                {/* <Group position="center" className={classes.orgDetails} py="xs" px="md" mb="sm">
                </Group> */}
            </NavLink>
        </Box>
    ) : null;
};
